import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, TextField } from "@mui/material";
import { searchWorkersAdmin } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import AccessForbidden from "../../../../../components/Access/AccessForbidden";
import Loading from "../../../../../components/Loading/Loading";

const ManageUsers = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const { register, handleSubmit, watch } = useForm<any>({
    defaultValues: {
      name: "",
      pts: "",
      phoneNumber: "",
      notes: "",
      pageNumber: 0,
    },
  });

  const watchFields = watch();

  const getWorkers = async (data: any) => {
    const response: any = await searchWorkersAdmin(state.user?.token, data);
    if (response?.response?.status === 403) {
      setIsAdmin(true);
    } else {
      setWorkers(response || []);
    }
    setLoading(false);
  };

  const handleClick = (userId: any) => {
    const url = `/pace-team/resourcing/dashboard/profile-data?userId=${userId}`;
    window.open(url, "_blank");
  };

  const handleClickEdit = (userId: any) => {
    const url = `/pace-team/resourcing/dashboard/edit-user?userId=${userId}`;
    window.open(url, "_blank");
  };

  const columns: any = [
    {
      field: "name",
      headerName: "Full Name",
      flex: 1.3,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.id)}
          style={{ cursor: "pointer" }}
        >
          {params.row.name} {params.row.surname}
        </div>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "pts",
      headerName: "PTS",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.3,
    },
    {
      field: "verified",
      headerName: "Verified",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => (
        <div>
          {params.row.verified ? (
            <FontAwesomeIcon icon={faCheck} size={"lg"} color={"green"} />
          ) : (
            <FontAwesomeIcon icon={faX} size={"lg"} color={"red"} />
          )}
        </div>
      ),
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.id)}
          style={{
            boxShadow: "none",
            backgroundColor: "#6c757d",
          }}
        >
          Details
        </Button>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClickEdit(params.row.id)}
          style={{
            boxShadow: "none",
            backgroundColor: "#6c757d",
          }}
        >
          Edit
        </Button>
      ),
    },
  ];

  useEffect(() => {
    setTimeout(() => {
      getWorkers(watchFields);
    }, 500);
  }, [
    watchFields.name,
    watchFields.pts,
    watchFields.phoneNumber,
    watchFields.notes,
  ]);

  useEffect(() => {
    getWorkers({});
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (isAdmin) {
    return <AccessForbidden />;
  }

  return (
    <>
      <div className="form-content">
        <TextField
          label="Full Name"
          type="text"
          size="small"
          {...register("name")}
          style={{ width: "17.5%", margin: 10 }}
        />
        <TextField
          label="PTS"
          type="text"
          size="small"
          {...register("pts")}
          style={{ width: "17.5%", margin: 10 }}
        />
        <TextField
          label="Phone Number"
          id="outlined-basic"
          variant="outlined"
          type="text"
          {...register("phoneNumber")}
          size="small"
          style={{ margin: 10, width: "17.5%" }}
        />
        <TextField
          label="Notes"
          id="outlined-basic"
          variant="outlined"
          type="text"
          {...register("notes")}
          size="small"
          style={{ margin: 10, width: "17.5%" }}
        />
        <Button
          variant="contained"
          onClick={handleSubmit(getWorkers)}
          style={{ height: 40, margin: 10, boxShadow: "none", width: "15%" }}
        >
          Filter
        </Button>
      </div>
      <Box sx={{ height: "730px", width: "90%", margin: "0 auto" }}>
        <DataGrid
          rows={workers}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15,
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#f0f0f0",
              color: "#000",
              fontWeight: "bold",
            },
            "& .disable-columns": {
              borderRight: "1px solid #bfbfbf",
            },
            "& .border-left": {
              borderLeft: "1px solid #bfbfbf",
            },
          }}
        />
      </Box>
    </>
  );
};

export default ManageUsers;
